module.exports = __webpack_public_path__ + "static/img/rank_24.0b3fda3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_24.png
// module id = IAmU
// module chunks = 0